import { CmsIds } from './CmsIds';
import { SignUpTypes } from './signUpType';

/**
 * Matches the experimental `<Select>`'s `SelectOption` shape, which
 * is not re-exported from `@kite-js/experimental`'s package root.
 */
export interface PartnerTypeSelectOption {
    value: string;
    label: string;
}

/** Partner types the user can pick from a `<Select>` in the signup flow. */
export type PartnerTypeChoice = SignUpTypes.Affiliate | SignUpTypes.Ambassador;

export const isPartnerTypeChoice = (n: number): n is PartnerTypeChoice =>
    n === SignUpTypes.Affiliate || n === SignUpTypes.Ambassador;

/**
 * Build the partner-type option list with CMS-driven labels.
 * Order is intentional: `Affiliate` first, then `Ambassador`.
 */
export const buildPartnerTypeItems = (
    cmsItems: Cms.CmsDictionary,
): PartnerTypeSelectOption[] => [
    {
        value: String(SignUpTypes.Affiliate),
        label: cmsItems[CmsIds.PartnerTypeAffiliateLabel],
    },
    {
        value: String(SignUpTypes.Ambassador),
        label: cmsItems[CmsIds.PartnerTypeAmbassadorLabel],
    },
];
